import {IMessengerOptions} from "./IMessengerOptions";
import {IMessengerEventHandlers} from "./IMessengerEventHandlers";
import {IMessengerHandler} from "./IMessengerHandler";
import {MessengerContainerComponent} from "./MessengerContainerComponent";
import {Component, lr} from "xm-ui";

export class DefaultMessengerHandler implements IMessengerHandler {
    private messenger: JQuery | null;

    public async tryShowMessenger(hostElement: JQuery, options: IMessengerOptions, eventHandlers: IMessengerEventHandlers): Promise<boolean> {
        this.messenger = await Component.mount(<MessengerContainerComponent {...options}/>, hostElement, false);
        this.messenger.on("hide", () => {
            this.messengerClosed();
            eventHandlers.hide();
        });

        return true;
    }

    public hideMessenger(): void {
        if (this.messenger != null) {
            this.messenger.data('component').hide();
        }
    }

    private messengerClosed() {
        this.messenger = null;
    }
}



// WEBPACK FOOTER //
// ./components/DefaultMessengerHandler.tsx